<template>
	<div>
		<div class="title">
			<div id="notice">
				<h5>首页提醒分配使用说明:<br>
					<span>1、配置名称和跳转标识。已经使用的名称可注释不可直接删除</span><br>
					<span>2、查询关键字:报表名称、角色</span><br>
				</h5>
			</div>
		</div>

		<pre-base ref="mybase" @base2-event="refresh_father" :pre_data="init_data">

		</pre-base>

	</div>
</template>

<script>
	export default {
		components: {
			"pre-base": () => import("../auto/auto_view_easy.vue")
		},
		data() {
			return {
				init_data: '',
				row_id: '',
				item: ''
			};
		},
		mounted: function() {
			var that = this;
			this.$nextTick(function() {
				that.fun_init();
			});
		},
		methods: {
			fun_init: function() {

				this.init_data = '';
				this.init_data = JSON.stringify({
					"title": '提醒范围配置',
					"control": "home_base",
					"isTwo": "0",
					"isTwoDetail": "1",
					"action_flag": "",
					"isFileMain": "1",
					"step": "0",
					"sel_action": 'exp_sys_home_base',
					"upd_action": 'exp15_sys_home_base',
					"detail_part": "0",
					"d_sel_action": '',
					"d_upd_action": '',
					"file_action": '',
					"p1": '',
					"p2": '',
					"p3": '',
					"parm_sel": [],
					"parm": [
						{
							"name": "名称",
							"val": "",
							"key": "h_name",
							"type": "text",
							"class": "long1",
							"p": "1",
							"w": "0",
							"r": "0",
							"x": "1"
						},
						{
							"name": "标识",
							"val": "",
							"key": "h_val",
							"type": "text",
							"class": "long1",
							"p": "1",
							"w": "0",
							"r": "0",
							"x": "1"
						},						
						{
							"name": "备注",
							"val": "",
							"key": "note",
							"type": "text",
							"class": "long1",
							"p": "1",
							"w": "0",
							"r": "0"
						}
					],
					"parm_th": [
						{
							"name": "序号"
						},
						{
							"name": "名称"
						},
						{
							"name": "标识"
						},
						{
							"name": "备注",
							"class": "long2"
						},
						// {
						//   "name": "附件"
						// },
						{
							"name": "状态",
							"class": "short0"
						},
						{
							"name": "修改人",
							"class": "short0"
						},
						// {
						//   "name": "路径1"
						// },
						// {
						//   "name": "路径2"
						// },
						{
							"name": "修改时间",
							"class": "long2"
						}
					],
					"d_parm": [],
					"d_name": []

				});
			},
			refresh_data: function(type) {
				var that = this;
				this.$nextTick(function() {
					that.$refs['mybase'].refresh_data(type);
				});
			},
			refresh_father: function(type, val, parm) {
				// console.log('type=' + type + ' val=' + val);
				switch (type) {
					case 'father':
						// 弹出修改明细，修改主窗口信息
						this.refresh_data();
						break;
					default:
						// console.log('子组件刷新父组件传值=' + val);
						this.row_id = val;
						this.item = parm;
						break;
				}
			}



		}
	};
</script>
<style scoped>
	/* 设置 倒数 第二、第三列 隐藏 */
	.path_none>td:nth-last-child(3),
	.path_none>td:nth-last-child(2) {
		display: none;
	}
</style>
